import type { TFunction } from "i18next";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3106ExpenseTypeSearchRow } from "../../U3106Service";

interface U3106ExpenseTypeDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn<U3106ExpenseTypeSearchRow>;
  t: TFunction;
  NS: string;
}

function U3106ExpenseTypeDeleteDlg({ handleDelete, t, NS }: U3106ExpenseTypeDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  const rows = handleDelete.selectedRows();
  const count = rows.length;

  return (
    <U2000DeleteRecordDialog isOpen={handleDelete.isDialogDeleteOpen} onClose={handleDelete.handleDeleteCloseDlg} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t(count === 1 ? "msgDeleteExpenseType" : "msgDeleteExpenseType_other", {
          count,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {rows.map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.code ?? row.id}${row.description ? ` — ${row.description}` : ""}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3106ExpenseTypeDeleteDlg;
